import axios from "axios";

export async function fetchAllProductsCategory() {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/categories`);
    return response.data;
}


export async function fetchAllProductsByFilters(filter, sort, pagination, search) {
    let queryString = "";

    for (let key in filter) {
        const categoryValues = filter[key];
        if (categoryValues.length > 0) {
            const categoryLastValue = categoryValues[categoryValues.length - 1];
            queryString += `${key}=${categoryLastValue}&`;
        }

    }
    for (let key in sort) {
        queryString += `${key}=${sort[key]}&`;
    }

    for (let key in pagination) {
        queryString += `${key}=${pagination[key]}&`;
    }

    if (search) {
        queryString += `q=${search}&`;
    }

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/products?${queryString}`);
    const totalCount = await res.headers["x-total-count"]; //Sending from backend server

    return { data: { products: res.data, totalItems: +totalCount } }
}

export async function fetchProductByProductId(productId) {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/products/${productId}`);

    return response.data;
}

